import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEditBookMutation } from "../../features/api/apiSlice";

export default function EditBookForm({book}) {
    const navigate = useNavigate();
    
    const { 
        id, 
        name: currName, 
        author: currAuthor, 
        thumbnail: currThumbnail, 
        price: currPrice,
        rating: currRating, 
        featured: currFeatured 
    } = book;

    const [ editBook, {isSuccess, isError} ] = useEditBookMutation();

    const [name, setName] = useState(currName);
    const [author, setAuthor] = useState(currAuthor);
    const [thumbnail, setThumbnail] = useState(currThumbnail);
    const [price, setPrice] = useState(currPrice);
    const [rating, setRating] = useState(currRating);
    const [featured, setFeatured] = useState(currFeatured);

    useEffect(() => {
        if (isSuccess) {
            navigate("/");
        }
    }, [isSuccess, navigate]);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        editBook({
            id,
            data: {
                name,
                author,
                thumbnail,
                price: Number(price),
                rating: Number(rating),
                featured
            } 
        });
    }

	return (
		<form onSubmit={handleFormSubmit} className="book-form">
			<div className="space-y-2">
				<label htmlFor="lws-bookName">Book Name</label>
				<input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
					required
					className="text-input"
					type="text"
					id="lws-bookName"
					name="name"
				/>
			</div>

			<div className="space-y-2">
				<label htmlFor="lws-author">Author</label>
				<input
                    value={author}
                    onChange={(e) => setAuthor(e.target.value)}
					required
					className="text-input"
					type="text"
					id="lws-author"
					name="author"
				/>
			</div>

			<div className="space-y-2">
				<label htmlFor="lws-thumbnail">Image Url</label>
				<input
                    value={thumbnail}
                    onChange={(e) => setThumbnail(e.target.value)}
					required
					className="text-input"
					type="text"
					id="lws-thumbnail"
					name="thumbnail"
				/>
			</div>

			<div className="grid grid-cols-2 gap-8 pb-4">
				<div className="space-y-2">
					<label htmlFor="lws-price">Price</label>
					<input
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
						required
						className="text-input"
						type="number"
						id="lws-price"
						name="price"
					/>
				</div>

				<div className="space-y-2">
					<label htmlFor="lws-rating">Rating</label>
					<input
                        value={rating}
                        onChange={(e) => setRating(e.target.value)}
						required
						className="text-input"
						type="number"
						id="lws-rating"
						name="rating"
						min="1"
						max="5"
					/>
				</div>
			</div>

			<div className="flex items-center">
				<input
                    checked={featured}
                    onChange={() => setFeatured(!featured)}
					id="lws-featured"
					type="checkbox"
					name="featured"
					className="w-4 h-4"
				/>
				<label htmlFor="lws-featured" className="ml-2 text-sm">
					{" "}
					This is a featured book{" "}
				</label>
			</div>

            { isError && <p className="error">There was an error</p> }

			<button type="submit" className="submit" id="lws-submit">
				Edit Book
			</button>
		</form>
	);
}
